import type { Maybe } from '@backmarket/utils/types/Maybe'

export function textToSlug(title: Maybe<string>, headingType?: string) {
  if (!title) return ''

  let slug = title
  if (headingType) slug = `${headingType}-${title}`

  return slug.toLowerCase().trim().replace(/\s+/g, '-')
}
